import angular from 'angular';
import template from './qr.html';

const qrConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('qr', {
		title:      'QR code',
		group:      'advanced',
		template,
		views:      [
			{
				name:     'Display',
				template: 'kform/components/qr/display.html',
			},
			{
				name:     'API',
				template: 'kform/components/qr/api.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		children:   false,
		selectable: true,
		settings:   {
			input:     false,
			tableView: true,
			label:     'QR code',
			key:       'qr',
			hideLabel: false,
			disabled:  false,
			hidden:    false,
			options:   {
				errorCorrectionLevel: 'M',
				margin: 4,
				scale: 4,
				small: false,
				color: {
					dark: '#000000',
					light: '#ffffff',
				},
			},
		},
		icon:       'fa fa-qrcode',
	});
};

export default angular.module('app').config(qrConfig);
